'use client'

import React from 'react'
import Image from 'next/image'
import { GoalProps, GoalSectionProps } from '@/widgets/landing-page-widgets/GoalSelection/schema'

import { Typography } from '@pw-tech/omni-ui'
import {
  BEAKER_ICON,
  BULB_ICON,
  GLOBE_ICON,
  HEADING_TOP_DECORATOR,
  ROCKET_ICON,
  RULER_ICON,
} from '@/components/RevampedLanding/contants'
import { APP_REDIRECTION_SCREENS } from '@/utils/enums'
import GoalCard from './GoalCard'

const GoalSelection = ({
  goalsData,
  appRedirectionScreen = APP_REDIRECTION_SCREENS.PAYMENT,
  isOtplessEnabled,
}: {
  goalsData: GoalSectionProps
  appRedirectionScreen: APP_REDIRECTION_SCREENS
  isOtplessEnabled: boolean
}) => {
  const headingExceptLastWord = goalsData?.heading?.split(' ').slice(0, -1).join(' ')

  const bgUrl = goalsData?.backgroundImage
  return (
    <div
      id='learning-section'
      className="py-8 md:py-[52px] relative overflow-hidden"
      style={{
        backgroundImage: `radial-gradient(100% 100% at 50% 0%, rgba(255,255,255,0) 70%, rgba(255,157,91,0.15) 100%), url(${bgUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: 'clamp(560px, 70vh, 820px)',
      }}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2 min-h-[58px]">
            <Typography variant='heading2' weight='bold' className="text-center" color='#3d3d3d'>
              <span className='relative'>
                {headingExceptLastWord}
                <span>
                  {' '}
                  <span className="relative">
                    {goalsData?.heading?.split(' ').slice(-1)}
                    <span className="absolute -top-[6px] -right-[10px] md:-top-5 md:-right-6 md:w-9 md:h-9 w-4 h-4">
                      <Image
                        src={HEADING_TOP_DECORATOR}
                        width={36}
                        height={36}
                        alt='text-top-icon'
                        priority
                      />
                    </span>
                  </span>
                </span>
              </span>
            </Typography>
            <Typography variant='heading4' className="text-center" color='#757575'>
              {goalsData?.subHeading}
            </Typography>
          </div>

          <div className="w-full flex flex-col md:grid md:grid-cols-3 gap-4 md:gap-5 py-2 z-10 overflow-hidden">
            {goalsData?.goals?.map((goal: GoalProps) => {
              return (
                <GoalCard
                  key={goal?.cohortId}
                  data={goal}
                  goals={goalsData?.goals}
                  appRedirectionScreen={appRedirectionScreen}
                  isOtplessEnabled={isOtplessEnabled}
                />
              )
            })}
          </div>
        </div>
      </div>
  <div className="absolute bottom-20 left-[-50px] md:bottom-28 md:left-0 w-[100px] h-[130px]">
        <Image width={100} height={130} src={GLOBE_ICON} alt='globe-icon' loading='lazy' />
      </div>
  <div className="absolute md:bottom-14 md:left-16 left-0 bottom-2 w-[68px] h-[71px]">
        <Image width={68} height={71} src={BULB_ICON} alt='bulb-icon' loading='lazy' />
      </div>
  <div className="absolute md:bottom-9 md:left-52 bottom-2 left-40 w-[56px] h-[56px]">
        <Image width={56} height={56} src={RULER_ICON} alt='ruler-icon' loading='lazy' />
      </div>
  <div className="absolute md:right-0 md:bottom-28 bottom-20 right-[-30px] w-[131px] h-[141px]">
        <Image width={131} height={141} src={BEAKER_ICON} alt='beaker-icon' loading='lazy' />
      </div>
  <div className="absolute md:right-0 md:bottom-12 bottom-0 right-[-26px] w-[166px] h-[80px]">
        <Image width={166} height={80} src={ROCKET_ICON} alt='rocket-icon' loading='lazy' />
      </div>
    </div>
  )
}

export default GoalSelection
